import React, {Fragment, useEffect} from "react";
import { connect } from "react-redux";
import $ from "jquery";

import {
  setUnlockCalculationsStep, showUnlockCalculationsCartItems,
  showUnlockCalculationsTotalItems
} from "../../../../../actions/unlockCalculationsFunctions";
import {CART_ITEM_ADDED_BY} from "../../../../shoppingCart/cartItemInterface";
import UnlockCalculationStep from "./unlockCalculationStep";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import {sortCartItemsForListPage} from "../../../lookNavigation/lookFunctions2";
import {ROUTES} from "../../../../../routes";
import {showWizardInsteadOfQT} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import {WIZARD_GROUP_TYPES} from "../../../../../interfaces/wizardItemInterface";
import {isSameVisualizerWizard} from "../../../lookNavigation/lookMain/lookWizard/lookWizardFunctions2";

export const getUnlockCalculationsCartItems = (cartItems, wizardList, wizardIsActive, allWizardsValues, lookPageOpened, quotes) => {
  let cartItemsToInclude = [];
  if (showWizardInsteadOfQT(wizardList, wizardIsActive)) {
    quotes.forEach((quote, quoteIndex) => {
      wizardList.forEach(wizardItem => {
        const existingAllObject = allWizardsValues.find(wizSelObject => {
          return wizSelObject.wizardItemId === wizardItem.id && wizSelObject.quoteIndex === quoteIndex
            && isSameVisualizerWizard(wizSelObject)
        });
        if (existingAllObject && existingAllObject.wizardSelectedValues) {
          Object.keys(existingAllObject.wizardSelectedValues).forEach(key => {
            if (existingAllObject.wizardSelectedValues[key].wizardGroup
                && existingAllObject.wizardSelectedValues[key].wizardGroup.nodeType === WIZARD_GROUP_TYPES.custom) {
              cartItemsToInclude.push({
                id: quoteIndex + existingAllObject.wizardSelectedValues[key].wizardGroup.id
              });
            }
            let currentCartItems = cartItems.filter(cartItem => {
              return cartItem.cartFeature && (cartItem.currentQuote === quoteIndex)
                  && +key === cartItem.fromWizardStep
                  && !cartItemsToInclude.includes(cartItem.id)
            });
            if (currentCartItems.length) {
              cartItemsToInclude = [...cartItemsToInclude, ...currentCartItems];
            }
          })
        }
      })
      cartItems.forEach(cartItem => {
        if (!cartItemsToInclude.some(cItem => cItem.id === cartItem.id)) {
          cartItemsToInclude = [...cartItemsToInclude, cartItem];
        }
      })
    })
  } else {
    cartItemsToInclude = cartItems;
  }
  if (IS_PRODUCT_JOURNEY) {
    cartItemsToInclude = cartItemsToInclude.filter(cItem => cItem.addedBy === CART_ITEM_ADDED_BY.user);
  } else if (lookPageOpened === ROUTES.list) {
    cartItemsToInclude = sortCartItemsForListPage(cartItemsToInclude)
  }

  return cartItemsToInclude
}

const UnlockCalculationSteps = (props) => {

  const {setUnlockCalculationsStep, cartItems, showUnlockCalculationsCartItems, showUnlockCalculationsTotalItems,
    lookPageOpened, wizardList, wizardIsActive, allWizardsValues, quotes} = props;

  const cartItemsToInclude = getUnlockCalculationsCartItems(cartItems, wizardList, wizardIsActive,
      allWizardsValues, lookPageOpened, quotes);

  useEffect(() => {
    runAnimations()
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return () => {
      showUnlockCalculationsCartItems([]);
      showUnlockCalculationsTotalItems([]);
      setUnlockCalculationsStep(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const animateCartItems = async () => {
    let showCartItems = [];
    for (const [elementIndex, element] of cartItemsToInclude.entries()) {
      // const waitTime = this.props.cartItems.length < 7 ? 500*(index + 1) : 300*(index + 1);
      if (elementIndex <= 1) {
        await new Promise(resolve => setTimeout(resolve, 750));
        showCartItems.push(element.id);
        showUnlockCalculationsCartItems([...showCartItems]);
      } else {
        setTimeout(() => {
          showCartItems.push(element.id);
          showUnlockCalculationsCartItems([...showCartItems]);
        }, 750 * (elementIndex - 1))
      }
    }
  };

  const showTotalItems = async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    showUnlockCalculationsTotalItems(["tax"]);
    await new Promise(resolve => setTimeout(resolve, 1000));
    showUnlockCalculationsTotalItems(["tax", "total"]);
    await new Promise(resolve => setTimeout(resolve, 1500));
    showUnlockCalculationsTotalItems(["tax", "total", "checkout"]);
  };

  const runAnimations = async () => {
    await new Promise(resolve => setTimeout(resolve, 500));
    await animateCartItems();
    await new Promise(resolve => setTimeout(resolve, 1500));
    setUnlockCalculationsStep(1);
    await new Promise(resolve => setTimeout(resolve, 2000));
    setUnlockCalculationsStep(2);
    await showTotalItems();
    await exitAnimations();
  };

  const exitAnimations = async () => {
    const overlayElement = document.querySelector(".look-overlay--style");
    if (overlayElement) {
      setUnlockCalculationsStep(3);
      $(overlayElement).fadeOut(300, () => {
        window.clearTimeout(window.leadCaptureTimeoutId);
        window.leadCaptureTimeoutId = setTimeout(() => {
          setUnlockCalculationsStep(4);
          $(overlayElement).fadeIn(300);
        }, 4000);
      })
    } else {
      setUnlockCalculationsStep(3);
    }
  };

  return (
    <Fragment>
      {[0,1,2].map(stepIndex => <UnlockCalculationStep stepIndex={stepIndex} key={stepIndex}/>)}
    </Fragment>
  )
};

const mapStateToProps = (store) => {
  const {unlockCalculationsStep, showTotalItems} = store.unlockCalculationsState;
  const {cartItems} = store.cartState;
  const {lookPageOpened} = store.lookState;
  const {wizardList, wizardIsActive, allWizardsValues} = store.wizardState;
  const {quotes} = store.quotesState;

  return {
    cartItems,
    unlockCalculationsStep,
    showTotalItems,
    lookPageOpened,
    wizardList,
    wizardIsActive,
    allWizardsValues,
    quotes,
  };
};

const mapDispatchToProps = {
  setUnlockCalculationsStep,
  showUnlockCalculationsCartItems,
  showUnlockCalculationsTotalItems,
};

export default connect(mapStateToProps, mapDispatchToProps)(UnlockCalculationSteps)
